import React from "react";
import { Home, Building2, Phone, Image, Heart } from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useMediaQuery } from "@/hooks/use-media-query";
import { Link } from "react-router-dom";

interface TabNavigationProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
}

export function TabNavigation({ activeTab, setActiveTab }: TabNavigationProps) {
  const isMobile = useMediaQuery("(max-width: 768px)");
  
  const handleTabChange = (value: string) => {
    setActiveTab(value);
    
    // On mobile, scroll to top when changing tabs for better UX
    if (isMobile) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-white border-b sticky top-0 z-10 shadow-sm">
      <div className="container px-0">
        <Tabs value={activeTab} onValueChange={handleTabChange} className="w-full">
          <TabsList className="flex justify-start overflow-x-auto p-0 bg-transparent border-b-0 w-full h-auto ml-0 sm:ml-6">
            <TabsTrigger 
              value="overview" 
              className="py-3 sm:py-4 px-4 sm:px-6 flex-1 sm:flex-initial text-sm sm:text-base flex items-center"
            >
              <Home className="h-4 w-4 mr-2" />
              <span className="sm:inline">Overview</span>
            </TabsTrigger>
            <TabsTrigger
              value="facilities"
              className="py-3 sm:py-4 px-4 sm:px-6 flex-1 sm:flex-initial text-sm sm:text-base flex items-center"
            >
              <Building2 className="h-4 w-4 mr-2" />
              <span className="sm:inline">Facilities & Amenities</span>
            </TabsTrigger>
            <TabsTrigger
              value="contact"
              className="py-3 sm:py-4 px-4 sm:px-6 flex-1 sm:flex-initial text-sm sm:text-base flex items-center"
            >
              <Phone className="h-4 w-4 mr-2" />
              <span className="sm:inline">Contact</span>
            </TabsTrigger>
            <TabsTrigger
              value="gallery"
              className="py-3 sm:py-4 px-4 sm:px-6 flex-1 sm:flex-initial text-sm sm:text-base flex items-center"
            >
              <Image className="h-4 w-4 mr-2" />
              <span className="sm:inline">Gallery</span>
            </TabsTrigger>
            <Link
              to="/home-care"
              className="py-3 sm:py-4 px-4 sm:px-6 flex-1 sm:flex-initial text-sm sm:text-base flex items-center text-muted-foreground hover:text-primary transition-colors whitespace-nowrap"
            >
              <Heart className="h-4 w-4 mr-2" />
              <span className="sm:inline">Home Care Directory</span>
            </Link>
          </TabsList>
        </Tabs>
      </div>
    </div>
  );
}
